module.exports = __webpack_public_path__ + "img/incognito.4e27cf48.png";